import React, { useState } from "react"
import { View, StyleSheet, ScrollView, Dimensions, TouchableOpacity } from "react-native"
import { Button } from "@Components/CustomButton/Button"
import { ContainerGlogal } from "@Components/ContainerGlogal"
import { InputGroup } from "@Components/Input/InputGroups"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { LoginService } from "@Services/Login.Service"
import { Ionicons } from "@expo/vector-icons"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { useSetRecoilState } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { UserService } from "@Services/User.service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { LoadingPage } from "@Screens/Loading/Loading"
import { isValidEmail } from "@Utils/utils"
import { LOGIN_ERROR } from "@Constants/constant"
import Constants from "expo-constants"

const { platform } = Constants.expoConfig.extra

// LaProvidence !
// visiomobile@yopmail.com file2@yopmail.com fitiapatientprod@yopmail.com
// 5lRRWpqCjJw6 1yVg9CBzk8wy Pass1234!

// Compte test Apple
// userapple@toolbox.ovh
// jRGeWXMhlKdG

const defaultCredential = {
    username: "",
    password: ""
}

const { height } = Dimensions.get("screen")

console.log({ loginPagePlateforme: platform })

const LoginPage = ({ navigation }) => {
    const setUserData = useSetRecoilState(userAtom)
    const [loading, setLoading] = useState(false)
    const [loadingUserData, setLoadingUserData] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [credential, setCredential] = useState(defaultCredential)
    const [message, setMessage] = useState("")
    const canSubmit = () => !(isValidEmail(credential?.username) && credential?.password?.length > 5)
    const gotoForgotPassword = () => navigation.navigate("Forgot-password")

    const gotoMain = () => {
        setLoadingUserData(true)
        UserService.getUserData()
            .then((response) => {
                const data = response.data.data
                setLoadingUserData(false)
                if (data) {
                    setUserData(data)
                    navigation.navigate("Main", { screen: "Home" })
                }
            })
            .catch((e) => {
                ShowToast({ type: "error", message: "Une erreur est survenue" })
                setLoadingUserData(false)
            })
    }

    const performLogin = async () => {
        await LocalStorage.saveTestUser(credential.username)
        setLoading(true)
        setHasError(false)
        LoginService.login(credential)
            .then((response) => {
                if (response.status === 200) {
                    LocalStorage.saveToken(response.data.token)
                    LocalStorage.resetSurveyResponse()
                    setLoading(false)
                    setHasError(false)
                    setCredential(defaultCredential)
                    gotoMain()
                }
            })
            .catch((e) => {
                const response = e.response
                console.log(response?.data)
                if (response?.data?.code === 401) {
                    if (response?.data?.message == LOGIN_ERROR.NOT_ACTIVATED) {
                        navigation.navigate("Activation", { email: credential.username })
                    } else {
                        setHasError(true)
                        setMessage("Identifiant incorrect.")
                    }
                } else {
                    ShowToast({ type: "error", message: "Problème de connexion avec le serveur" })
                }
                setLoading(false)
            })
    }

    if (loadingUserData) {
        return <LoadingPage />
    }

    return (
        <ContainerGlogal>
            <ScrollView keyboardShouldPersistTaps={"handled"} contentContainerStyle={{ paddingBottom: 50 }}>
                <View style={styles.container}>
                    <BreeSerifText
                        style={{ textAlign: "center", fontSize: 30, color: baseColors.green.primary, marginBottom: 20 }}
                    >
                        Connexion
                    </BreeSerifText>

                    <View style={{ marginTop: 20 }}>
                        <InputGroup
                            disabled={loading}
                            onChange={(text) => {
                                setCredential((old) => ({ ...old, username: text?.trim() }))
                            }}
                            valid={isValidEmail(credential?.username)}
                            value={credential?.username?.trim()}
                            validation_message={"obligatoire"}
                            label={"Adresse mail"}
                            placeholder={"Entrez votre adresse mail"}
                        />
                        <InputGroup
                            disabled={loading}
                            onChange={(text) => {
                                setCredential((old) => ({ ...old, password: text }))
                            }}
                            valid={credential.password.length > 5}
                            value={credential.password}
                            type="password"
                            validation_message="min. 8 caractères"
                            label="Mot de passe"
                            placeholder="Minimum 8 caractères"
                        />

                        {hasError && (
                            <View
                                style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <Ionicons name="warning" size={23} color={baseColors.orange.primary} />
                                <BreeSerifText
                                    textAlign={"center"}
                                    color={baseColors.orange.primary}
                                    fontSize={16}
                                    fontWeight={"normal"}
                                >
                                    {message}
                                </BreeSerifText>
                            </View>
                        )}
                    </View>

                    <Button
                        loading={loading}
                        disabled={canSubmit() || loading}
                        onPress={() => performLogin()}
                        text="Se connecter"
                        width="80%"
                        height={45}
                        backgroundColor={baseColors.green.primary}
                        labelColor="white"
                    />
                    <TouchableOpacity
                        disabled={loading}
                        style={{ marginTop: 20, marginBottom: height / 7 }}
                        activeOpacity={0.5}
                        onPress={() => gotoForgotPassword()}
                    >
                        <OpenSansText
                            textAlign="center"
                            color={baseColors.green.primary}
                            fontSize={16}
                            fontWeight="bold"
                        >
                            Mot de passe oublié
                        </OpenSansText>
                    </TouchableOpacity>
                </View>
            </ScrollView>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 20,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    text: {
        color: baseColors.black,
        textAlign: "justify",
        fontFamily: "BreeSerif",
        fontSize: 16
    }
})

export default LoginPage
